export default {
	apiUrl: '//pz.csgosmurfsale.com/api/v1/mail',
	domain: 'theggmail.com'
}



//////////////////
// WEBPACK FOOTER
// ./config/apiconfig.js
// module id = null
// module chunks = 